var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled, { css } from "styled-components";
import { copyFontSize, copyFontSizeSmall, copyColor, colorBrandBase, colorWhite, colorLighter, focusOutlineColor, focusOutlineStyle, focusOutlineWidth, focusOutlineOffset } from "@nib-components/theme";
import { ChevronRightSystemIcon } from "@nib/icons";
import { Box, Columns, Column } from "@nib/layout";
var truncatedTextStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"]))); // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var SubTitle = styled(function (_ref) {
  var truncate = _ref.truncate,
      rest = _objectWithoutProperties(_ref, ["truncate"]);

  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts && theme.fonts.sansSerif || theme.fonts.copy || "sans-serif";
}, copyFontSizeSmall, function (_ref3) {
  var truncate = _ref3.truncate;
  return truncate && truncatedTextStyles;
}); // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var Title = styled(function (_ref4) {
  var truncate = _ref4.truncate,
      rest = _objectWithoutProperties(_ref4, ["truncate"]);

  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.fonts && theme.fonts.sansSerif || theme.fonts.copy || "sans-serif";
}, copyFontSize, function (_ref6) {
  var truncate = _ref6.truncate;
  return truncate && truncatedTextStyles;
});
var Chevron = styled(ChevronRightSystemIcon)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  color: ", ";\n"])), colorBrandBase);
var Wrapper = styled(Box)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: block;\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  text-decoration: none;\n  border: none;\n  line-height: inherit;\n  text-align: left;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", "\n\n  ", " {\n    transition: transform 200ms;\n  }\n\n  &:hover ", ", &:focus ", " {\n    transform: translateX(4px);\n  }\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: ", ";\n  }\n\n  svg {\n    display: block;\n  }\n"])), colorWhite, copyColor, function (_ref7) {
  var showBorder = _ref7.showBorder;
  return showBorder && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n    "])), colorLighter);
}, Chevron, Chevron, Chevron, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
var FullHeightColumns = styled(Columns)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  height: 100%;\n"])));

var UtilityButton = function UtilityButton(props) {
  var Icon = props.icon,
      showBorder = props.showBorder,
      showChevron = props.showChevron,
      subtitle = props.subtitle,
      title = props.title,
      href = props.href,
      onClick = props.onClick,
      component = props.component,
      truncate = props.truncate,
      otherProps = _objectWithoutProperties(props, ["icon", "showBorder", "showChevron", "subtitle", "title", "href", "onClick", "component", "truncate"]); // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var element = component ? component : onClick ? "button" : "a";
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    paddingVertical: 3,
    paddingHorizontal: 4,
    borderRadius: "standard",
    showBorder: showBorder,
    showChevron: showChevron,
    as: element,
    href: href,
    onClick: onClick
  }, otherProps), /*#__PURE__*/React.createElement(FullHeightColumns, {
    space: 4,
    verticalAlign: "center"
  }, Icon && /*#__PURE__*/React.createElement(Column, {
    width: "content"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "md"
  })), /*#__PURE__*/React.createElement(Column, null, subtitle && /*#__PURE__*/React.createElement(SubTitle, {
    truncate: truncate
  }, subtitle), /*#__PURE__*/React.createElement(Title, {
    truncate: truncate
  }, title)), showChevron && /*#__PURE__*/React.createElement(Column, {
    width: "content"
  }, /*#__PURE__*/React.createElement(Chevron, {
    size: 20
  }))));
};

UtilityButton.displayName = "UtilityButton";
UtilityButton.defaultProps = {
  showBorder: false,
  showChevron: true,
  truncate: false
};
export default UtilityButton;